import React from "react";
import PropTypes from "prop-types";
import { activeFormatter } from "Utils/Acciones/Acciones";
import { Link } from "react-router-dom";
import moment from "moment";
import Grid from "../../Utils/Grid/materialTable";
import { marketingBlogPosts, marketingBlogPostsNew } from "../../../../routesConfiguration/paths";

export default class BlogPostsGrid extends React.Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired,
        find: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
    }

    componentDidMount() {
        if (this.tableRef && this.tableRef.current)
            this.tableRef.current.dataManager.changePageSize(10);

        this.props.find();
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.userInfo && this.props.userInfo){
            const { permission } = this.props.userInfo;
            const { permission: oldPermission } = prevProps.userInfo;
            if(oldPermission && permission && JSON.stringify(oldPermission) !== JSON.stringify(permission)){
                if(permission.find(({ readBlogPost }) => readBlogPost))
                    this.props.find();
            }
        }
    }

    render() {
        const { data, loading, destroy, find, page, setSearch, userInfo: { permission } } = this.props;

        return (
            <div className="row">
                <div className="col-sm-12 pt-2">
                    <div className="grid-container material-livery-list">
                        {permission &&
                            permission.find(({ readBlogPost }) => !!readBlogPost) && (
                                <Grid
                                    tableRef={this.tableRef}
                                    title="Blog Posts"
                                    columns={[
                                        {
                                            title: "Title",
                                            field: "title",
                                        },
                                        {
                                            title: "Created",
                                            field: "createdAt",
                                            width: "18%",
                                            render: (row) => moment(row.createdAt).format("MM/DD/YYYY")
                                        },
                                        {
                                            title: "Published",
                                            field: "published",
                                            width: "15%",
                                            render: (row) => row.published ? "Yes": "Not"
                                        },
                                        {
                                            title: "Published date",
                                            field: "publishedAt",
                                            width: "18%",
                                            render: (row) =>
                                                row.publishedAt
                                                    ? moment(row.publishedAt).format("MM/DD/YYYY")
                                                    : "---"
                                        },
                                        {
                                            title: "Actions",
                                            field: "_id",
                                            align: "center",
                                            width: "13%",
                                            render: (row) =>
                                                activeFormatter({
                                                    editar: permission.find(({ updateBlogPost }) => !!updateBlogPost) && marketingBlogPosts,
                                                    eliminar: permission.find(({ removeBlogPost }) => !!removeBlogPost) && destroy,
                                                })(row._id, row),
                                        },
                                    ]}
                                    actions={[
                                        {
                                            icon: () =>
                                                permission && permission.find(({ createBlogPost }) => !!createBlogPost) && (
                                                    <Link
                                                        className="btn btn-primary px-2 py-0 align-self-end rounded-circle"
                                                        to={marketingBlogPostsNew}
                                                    >
                                                        <h3>+</h3>
                                                    </Link>
                                                ),
                                            isFreeAction: true,
                                        },
                                    ]}
                                    data={data.data}
                                    onSearchChange={setSearch}
                                    onPageChange={(p) => find(p + 1)}
                                    isLoading={loading}
                                    page={page - 1}
                                    totalCount={data.total}
                                    options={{
                                        pageSizeOptions: [],
                                        filtering: false,
                                        idSynonym: "_id",
                                        pageSize: 10,
                                        headerStyle: {
                                            backgroundColor: "#D50032",
                                            color: "#FFF",
                                            fontSize: "1rem",
                                        },
                                        cellStyle: {
                                            fontSize: "1rem",
                                        },
                                    }}
                                />
                            )}
                    </div>
                </div>
            </div>
        );
    }
}
